module.exports = __webpack_public_path__ + "static/1-40a49417546c0614fa30ec455f1ccf2e.png";